import SafariPackageCardSkeleton from "components/common/Skeleton/packages/SafariPackageCardSkeleton";
import SafariPackageCard from "components/safaripackages/view/SafariPackageCard";
import { useWishListContext } from "provider/WishListProvider";
import { useMemo } from "react";
import { Col, Row } from "react-bootstrap";

const PackageWishLIst = () => {
    const { packges, summaryPack, errorPack, loadingPack, pageIndexPack, wishListDispatch } = useWishListContext();
    const processedSafariPackages = useMemo(() => {
        return packges?.map((packages) => ({
            ...packages
        }));
    }, [packges, pageIndexPack]);
    return (
        <>
            <Row className="row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-2 row-cols-xl-3 row-cols-xxl-3 g-lg-3 gx-lg-4 gx-xxl-4 pt-1 row">
                {errorPack && <p className="text-danger">{errorPack}</p>}

                {(Array.isArray(processedSafariPackages) && processedSafariPackages?.length > 0) ? (
                    processedSafariPackages.map((safariPackages, index) => (
                        <Col
                            className="mb-xl-2 mb-md-2 mb-3 padding_righ"
                            key={safariPackages.id || index}
                        >
                            <SafariPackageCard safariPackages={safariPackages} />
                        </Col>
                    ))
                ) : loadingPack ? (
                    <SafariPackageCardSkeleton count={6} />
                ) : (
                    <p>No Packages available</p>
                )}

            </Row>

            <div className="d-flex justify-content-center my-4">
                {loadingPack ? (
                    <div
                        className="spinner-border loading-spinner"
                        role="status"
                    >
                        <span className="visually-hidden">Loading...</span>
                    </div>
                ) : (
                    summaryPack?.page < summaryPack?.total_page && (
                        <button
                            className="join_btn newbgjoin mt-sm-0 mt-2"
                            onClick={() => {

                                const nextPage = pageIndexPack + 1
                                wishListDispatch({
                                    type: "SET_WISHLIST_PACKAGE_PAGE_INDEX",
                                    payload: nextPage,
                                });
                            }}
                        >
                            Show More Packages
                        </button>
                    )
                )}
            </div>

        </>
    )
}

export default PackageWishLIst